<template>
  <div>
    <NotificationMessage class="notification" />
    <div class="layout">
      <div class="grid" v-if="centers">
        <div class="grid-0">
          <div class="grid-map">
            <RegionButtons
              class="centers-buttons grid-map-0"
              :regions="regions"
              :selectedRegion="selectedRegion"
              @click="onRegionButtonClick"
              @mouseover="onRegionButtonMouseOver"
              @mouseleave="onRegionButtonMouseLeave"
            />
            <CentersMap
              class="centers-map grid-map-1"
              ref="map"
              :centers="centerGroups"
              @regionClick="onMapRegionClick"
              @departmentClick="onMapDepartmentClick"
              @markerClick="onMapMarkerClick"
            />
          </div>
        </div>
        <CentersList
          class="centers-list grid-1"
          :centers="filteredCenterGroups"
          @click="onCenterClick"
          @mouseover="onCenterMouseOver"
          @mouseleave="onCenterMouseLeave"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NotificationMessage from "@/components/components-base/notification/NotificationMessage";
import CentersList from "@/components/components-salles/public/center/map-overview/CentersList";
import CentersMap from "@/components/components-salles/public/center/map-overview/CentersMap";
import RegionButtons from "@/components/components-salles/public/center/map-overview/RegionButtons";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ViewCenters",
  components: {
    NotificationMessage,
    CentersList,
    CentersMap,
    RegionButtons,
  },
  data: () => ({
    regions: null,
    selectedRegion: undefined,
    selectedDepartment: undefined,
    selectedMarker: undefined,
    filteredCenters: [],
  }),
  computed: {
    ...mapGetters("centerModule", {
      centers: "getCenters",
      centerGroups: "getCenterGroups",
    }),
    ...mapGetters("locationModule", { locations: "getLocations" }),

    filteredCenterGroups() {
      return this.centerGroups
        .filter((x) => this.filteredCenters.includes(x))
        .sort((a, b) => a.centerGroupName.localeCompare(b.centerGroupName));
    },
  },
  methods: {
    ...mapActions("centerModule", ["loadCentersWithDependents"]),
    ...mapActions("bookingModule", ["loadBookingsWithDependents"]),

    handleSelection(cond, update) {
      if (cond) {
        update();
      } else {
        this.selectedRegion = undefined;
        this.selectedDepartment = undefined;
        this.selectedMarker = undefined;
        this.filteredCenters = this.centerGroups;
      }
    },
    selectRegion(region) {
      this.handleSelection(this.selectedRegion != region, () => {
        this.selectedRegion = region;
        this.selectedDepartment = undefined;
        this.selectedMarker = undefined;
        this.filteredCenters = region.centers;
      });
    },

    onRegionButtonClick(region) {
      this.selectRegion(region);
    },
    onRegionButtonMouseOver(region) {
      this.$refs.map.highlightRegion(region);
    },
    onRegionButtonMouseLeave(region) {
      this.$refs.map.unhighlightRegion(region);
    },

    onMapRegionClick(region) {
      if (region.centers.length == 0) return;
      this.selectRegion(region);
    },
    onMapDepartmentClick(department) {
      this.handleSelection(this.selectedDepartment != department, () => {
        this.selectedRegion = department.region;
        this.selectedDepartment = department;
        this.selectedMarker = undefined;
        this.filteredCenters = department.centers;
      });
    },
    onMapMarkerClick(marker) {
      this.handleSelection(this.selectedMarker != marker, () => {
        this.selectedRegion = marker.department.region;
        this.selectedDepartment = marker.department;
        this.selectedMarker = marker;
        this.filteredCenters = marker.department.centers;
      });
    },

    onCenterClick(center) {
      this.$router.push({
        name: "center-details",
        params: { centerGroupId: center.centerGroupId },
      });
    },
    onCenterMouseOver(center) {
      center.map.highlight();
    },
    onCenterMouseLeave(center) {
      center.map.unhighlight();
    },
  },
  async mounted() {
    await this.loadCentersWithDependents();
    this.loadBookingsWithDependents(); // async load bookings

    this.filteredCenters = this.centerGroups;
    this.$refs.map.render();
    this.regions = this.$refs.map.getRegions();
  },
};
</script>

<style lang="scss" scoped>
.notification {
  position: absolute;
  padding: 0 1.5rem;
  z-index: 100;
}

.layout {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

.grid-map {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 9fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.grid-map-0 {
  grid-area: 1 / 1 / 2 / 2;
}
.grid-map-1 {
  grid-area: 2 / 1 / 3 / 2;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 0fr;
  grid-template-rows: 1fr 0fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
  padding-bottom: 2%;
}
.grid-0 {
  grid-area: 1 / 1 / 3 / 2;
}
.grid-1 {
  grid-area: 1 / 2 / 2 / 3;
}

.centers-buttons {
  height: 70px;
  width: auto;
  max-width: 1200px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.centers-list {
  min-width: 295px;
}
</style>
